module.exports = __webpack_public_path__ + "static/img/news.5ff0971.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news.png
// module id = JmuL
// module chunks = 1